export const sortLegsByDate = (a, b) => new Date(a.timing.isoDate) - new Date(b.timing.isoDate);
